











import { defineComponent } from '@vue/composition-api'

export default defineComponent({
    name: "ActionAtom",
    props: {
        url: {
            type: String,
            required: false,
            default: null
        },
        icon: {
            type: String,
            required: true,
            default: ""
        },
        text: {
            type: String,
            required: true,
            default: ""
        },
        target: {
            type: String,
            required: false,
            default: null
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true
        },
        actionClass: {
            type: String,
            required: false,
            default: "cell small-12"
        }
    }
})
